import { TASK_TO_CONTACT, TASK_TO_COMPANY } from 'customer-data-objects/associations/AssociationTypes';
import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import AssociationTypeToAssociationTypeId from 'customer-data-objects/associations/AssociationTypeToAssociationTypeId';
import { DEFAULT_TASK_DUE_DATE_PRESET, DEFAULT_TASK_DUE_TIME_MINUTES } from 'customer-data-objects/task/TaskSettingDefaults';
import { userAttributesClient } from '../../client/userAttributesClient';
export const DONT_SHOW_FOLLOW_UP_TASK = 'Tasks:Queues:FollowUpTasks:hide';
export const DEFAULT_DUE_DATE_PRESET = 'Tasks:Defaults:DueDatePreset';
export const DEFAULT_DUE_TIME = 'Tasks:Defaults:DueTime';
export const DEFAULT_REMINDER_PRESET = 'Tasks:Defaults:ReminderPreset';
const TASKS_USER_SETTINGS = {
  [DONT_SHOW_FOLLOW_UP_TASK]: '',
  [DEFAULT_DUE_DATE_PRESET]: '',
  [DEFAULT_DUE_TIME]: '',
  [DEFAULT_REMINDER_PRESET]: ''
};
export function createTask(data, apiClient) {
  return apiClient.post('tasks/v2/tasks', {
    data
  });
}
export function createTaskRequest({
  taskDueDate,
  taskType,
  ownerId,
  title,
  body = '',
  primaryAssociationObjectId,
  primaryAssociationObjectTypeId
}) {
  return {
    properties: {
      hs_queue_membership_ids: null,
      hs_task_body: body,
      hs_task_priority: 'NONE',
      hs_task_relative_reminders: [],
      hs_task_reminders: [],
      hs_task_status: 'NOT_STARTED',
      hs_task_subject: title,
      hs_task_type: taskType,
      hs_timestamp: taskDueDate,
      hubspot_owner_id: ownerId
    },
    associations: [{
      associationCategory: 'HUBSPOT_DEFINED',
      associationTypeId: primaryAssociationObjectTypeId === CONTACT_TYPE_ID ? AssociationTypeToAssociationTypeId.get(TASK_TO_CONTACT) : AssociationTypeToAssociationTypeId.get(TASK_TO_COMPANY),
      toObjectId: primaryAssociationObjectId
    }]
  };
}
export const fetchTasksSettings = (__unusedKey, httpClient) => {
  return userAttributesClient.withHttpClient(httpClient).batchFetch(TASKS_USER_SETTINGS).then(values => {
    return {
      showFollowUpTasks: values[DONT_SHOW_FOLLOW_UP_TASK] === 'false',
      defaultDueDatePreset: values[DEFAULT_DUE_DATE_PRESET] ? JSON.parse(values[DEFAULT_DUE_DATE_PRESET]) : DEFAULT_TASK_DUE_DATE_PRESET,
      defaultDueTime: values[DEFAULT_DUE_TIME] ? JSON.parse(values[DEFAULT_DUE_TIME]) : DEFAULT_TASK_DUE_TIME_MINUTES,
      defaultReminderPreset: values[DEFAULT_REMINDER_PRESET] ? JSON.parse(values[DEFAULT_REMINDER_PRESET]) : null
    };
  });
};